import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import useSeo from "../hooks/useSeo";
import useEnforceLightMode from "../hooks/useEnforceLightMode";
import { GUIDES } from "../seo/guides";
import { breadcrumbJsonLd } from "../seo/site";
import { GUIDES_INDEX_SEO } from "../seo/pages";

export default function GuidesIndexPage() {
  useEnforceLightMode();
  useSeo({
    ...GUIDES_INDEX_SEO,
    path: "/guides",
    jsonLd: [breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Guides" }])],
  });

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-24 sm:pt-28 pb-16">
        <h1 className="text-3xl sm:text-4xl font-extrabold">Clearance & penny shopping guides</h1>
        <p className="mt-4 text-lg text-slate-600">{GUIDES_INDEX_SEO.description}</p>
        <ul className="mt-10 grid sm:grid-cols-2 gap-4">
          {GUIDES.map((g) => (
            <li key={g.slug}>
              <Link
                to={`/guides/${g.slug}`}
                className="flex h-full flex-col rounded-2xl border border-slate-200 p-5 hover:border-violet-300"
              >
                <BookOpen className="w-5 h-5 text-violet-700" />
                <span className="mt-3 text-lg font-bold">{g.h1}</span>
                <span className="mt-2 text-sm text-slate-600">{g.description}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
